import React from 'react';
import PrivateAPIResource from "../../services/PrivateAPIResource";

export default class DashboardTips extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        PrivateAPIResource.all('tips/random/4')
            .then(data => {
                this.setState({tips: data});
            });
    }

    render() {

        let {tips} = this.state;

        if (! tips) {
            return <div id='emptyTips'> </div>;
        } else {
            return <div className="row" id='tips'>
                <div className="col-12">
                    <div className="card-deck-wrapper">
                        <div className='card-deck'>
                        {
                            tips.map(tip => {
                                return <div className="card m-b-20 card-inverse card-grey" key={tip.id}>
                                        <div className="card-block">
                                            <h3 className="card-title font-20 mt-0">{tip.title}</h3>
                                            <p className="card-text">{tip.description}</p>
                                        </div>
                                    </div>
                            })
                        }
                        </div>
                    </div>
                </div>
            </div>
        }
    }
}


// WEBPACK FOOTER //
// ./web/src/components/tips/DashboardTips.jsx